export default "__VITE_PUBLIC_ASSET__cf311dba__"